module.exports = __webpack_public_path__ + "img/tapestry.31489319.png";